var lists_default = {
  "fontElementMap": "VnJFi",
  "orderedlist": "wNURH",
  "bulletedlist": "flj0N",
  "listItem": "-Z5zC"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
